import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMissingAccountExternalIdRedirect } from "@hooks";
import { PageWrapper } from "@containers/PageWrapper/pageWrapper";
import { Paper } from "@components/paper";
import { Loader } from "../../components/loader/loader";
import actions from "@redux/acceptAutoFinance/actions"
import SuccessClientMessage from './Components/successClientMessage';
import SuccessDealerMessage from './Components/successDealerMessage';
import FailedClientMessage from './Components/failedClientMessage';
import FailedDealerMessage from './Components/failedDealerMessage';

export const AcceptAutoFinance = () => {
    const { queryString } = useSelector(state => state.StartUp);
    const { hasAccepted, acceptFailed } = useSelector(state => state.acceptAutoFinance);
    const { dealer } = queryString || {};
    const dispatch = useDispatch();

    useMissingAccountExternalIdRedirect({
        onMountWithId: (accountExternalId) => {
            dispatch(actions.submitAcceptAutoFinance({accountExternalId}));
        }
    });

    const FailedAutoFinance = () => {
        if(dealer && dealer === 'true') {
            return <FailedDealerMessage />;
        }
        return <FailedClientMessage />;
    } 
    const SuccessAutoFinance = () => {
        if(dealer && dealer === 'true') {
            return <SuccessDealerMessage />;
        }
        return <SuccessClientMessage />;
    } 
    const RenderAutoFinance = () => {
        if(acceptFailed) {
            return (<PageWrapper>
                        <Paper>
                            <FailedAutoFinance />
                        </Paper>
                    </PageWrapper>);
        }
        if(hasAccepted) {
            return (<PageWrapper>
                        <Paper>
                            <SuccessAutoFinance />
                        </Paper>
                    </PageWrapper>); 
        }
        return  <Loader />
    } 

    return (
        <RenderAutoFinance />
    );
}
